// @flow

import 'bootstrap';
import MobileDetect from 'mobile-detect';

import React from 'react'
import ReactDOM from 'react-dom'
import Slider from 'react-slick'
import PropTypes from 'prop-types';
class SimpleSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      photos: JSON.parse(props.photos).map(image => (
        <img key={image.id_bien_photo} src={'images/photo/original/' + image.libelle} />
      )),
      settings: {
        customPaging: i => (
          <a>{this.state.photos[i]}</a>
        ),
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        lazyLoad: true
      }
    }
  }

  render () {
    return <div style={{
      padding: '0', 
      margin: '0',
      width: '95%'
    }}>
      <Slider {...this.state.settings}>
        {this.state.photos}
      </Slider>
    </div>
  }
}

SimpleSlider.propTypes = {
  photos: PropTypes.string
}

const slider = document.getElementById('slider')

if (slider) {
  ReactDOM.render(
    <SimpleSlider {...(slider.dataset)} />,
    slider
  )
}

let md = new MobileDetect(window.navigator.userAgent);
let mdDiv = document.getElementById('mobile-notification');

if (mdDiv && window.localStorage.getItem('modiledetectionclose') != 'close') {
  if (md.mobile() != null) {
    if (md.os() == 'iOS') {
      mdDiv.style.display = 'block';
      document.querySelector('.mobile-notification-text').innerHTML = 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez <span class="icon icon-ios7-home"></span> et sélectionnez <strong>Ajouter sur l\'écran d\'accueil</strong>.';
    } else if (md.os() == 'AndroidOS') {
      mdDiv.style.display = 'block';
      document.querySelector('.mobile-notification-text').innerHTML = 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez sur le bouton "menu", puis sur <strong>Ajouter sur l\'écran d\'accueil</strong>.';
    }
  }
    
  document.querySelector('.mobile-notification-close').addEventListener('click', function(e) {
    mdDiv.style.display = 'none';
    window.localStorage.setItem('modiledetectionclose', 'close');
  });
}



// WEBPACK FOOTER //
// ./src/app.js